import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "poll-quiz-result-container"
};
const _hoisted_2 = {
  key: 0,
  class: "quiz-result-label"
};
const _hoisted_3 = {
  class: "answers-options-container"
};
const _hoisted_4 = ["type", "name", "value", "checked"];
const _hoisted_5 = {
  class: "answer-label-stat-block"
};
const _hoisted_6 = {
  class: "answer-label"
};
const _hoisted_7 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  return _ctx.isLoading ? (_openBlock(), _createBlock(_component_loader, {
    key: 0
  })) : _ctx.quizStatisticsData ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.quizStatisticsData?.questionLabel,
    "label-detail": _ctx.quizStatisticsData?.questionInformation
  }, null, 8, ["label", "label-detail"]), _ctx.hasResultLabel ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('view.speach.pollQuiz.resultsLabel')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_ctx.quizStatisticsData?.responsesStats?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.quizStatisticsData.responsesStats, responseStats => {
    return _openBlock(), _createElementBlock("label", {
      key: responseStats.responseId,
      class: "answer-item",
      style: _normalizeStyle(_ctx.getVotesBackgroundStyle(responseStats.responseId))
    }, [_createElementVNode("input", {
      class: _normalizeClass(['answer-input', _ctx.questionCheckType === 'radio' ? 'answer-input-radio' : 'answer-input-checkbox']),
      type: _ctx.questionCheckType,
      name: _ctx.questionCheckType === 'radio' ? `question-${_ctx.quizStatisticsData.questionType}` : `${responseStats.responseId}`,
      value: responseStats.responseId,
      checked: _ctx.isSelected(responseStats.responseId),
      disabled: true
    }, null, 10, _hoisted_4), _ctx.userAnswersIds?.length ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: _normalizeClass(_ctx.questionCheckType === 'checkbox' ? 'checkbox-cell' : 'radio-cell')
    }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(responseStats.responseLabel), 1), _createElementVNode("div", {
      class: "answer-stats",
      innerHTML: _ctx.getAnswerStats(responseStats.responseId)
    }, null, 8, _hoisted_7)])], 4);
  }), 128)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true);
}